import DialogActions from './DialogActions';
export default DialogActions;